import { Link, useLocation } from "react-router-dom";
import appiceIcon from "../../images/Appice_Logo_new.png";
import "./HeaderNav.css";
import { Avatar, Dropdown, MenuProps } from "antd";
import { CaretDownFilled, LogoutOutlined, ProfileOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import CustomModal from "../Models/CustomModel/CustomModel";
import { t } from "i18next";
import { logoutUser } from "redux/features/user/loginUserSlice";
import { ROUTES } from "utils/constants";
import { formatRole } from "helperFunctions/common";
import { useDiagnosticsAuth } from 'pages/Diagnostics/context/DiagnosticsAuthContext';


interface HeaderNavProps {
  backgroundColor: string;
  name: string;
  onclick: () => void;
}

function HeaderNav({ backgroundColor, name, onclick }: HeaderNavProps) {

  const loginUser = useSelector((state: any) => state.loginUser);
  const rawUserRole = loginUser?.data?.activeAppUserRole || "no_role";
  const userRoleLabel = formatRole(rawUserRole);
  const location = useLocation();
  const isDeniedPage = location.pathname === "/denied"; 
  
const logoUrl = useSelector((state: any) => state?.siteSetting?.logoUrl);
  const [logoutModelOpen,setLogoutModelOpen]=useState(false)
  const dispatch:any = useDispatch();
  const items: MenuProps["items"] = [
     {
    key: "0",
    label: (
      <div className="user-role-display">
        Role: {userRoleLabel}
      </div>
    ),    
    disabled: true,
  },
    {
      key: "1",
      label: (
        
        <Link className="HeaderNav_links" to={"/dashboard/editProfile"}>
           <span className="d-flex align-items-center gap-2">
           <ProfileOutlined  />
            <span>Profile</span>
          </span>

        </Link>
      ),
    },
    {
      key: "2",
      label: (
        <Link
          className="HeaderNav_links pointer-cursor"
          onClick={() => setLogoutModelOpen(true)}
          to={"#"}
        >
          <span className="d-flex align-items-center gap-2">
            <LogoutOutlined />
            <span>Logout</span>
          </span>
        </Link>
      ),
    },
  ];
  
  const { isAuthenticated: isDiagnosticsAuthenticated, logout: diagnosticsLogout } = useDiagnosticsAuth();

  
  const handleDiagnosticsLogout = () => {
    diagnosticsLogout();
    window.location.href = '/diagnostics/login';
  };

  return (
    <nav
      className={`navbar top-navbar-main-container navbar-expand-lg bg-body-tertiary px-3 ${backgroundColor}`}
    >
      <CustomModal
      open={logoutModelOpen}
      closable={false}
       title={t("logoutLabel")}
       onCancel={()=>setLogoutModelOpen(false)}
       onOk={()=>{dispatch(logoutUser());setLogoutModelOpen(false)}}
       okText={t("logoutLabel")}
       cancelText={undefined}
      >
{t("areYouSureMsg")}
      </CustomModal>
      <div className="container-fluid d-flex">
        <div>
          <span className="mx-sm-0 mx-2"></span>
          <Link className="navbar-brand" to={`${ROUTES.DASHBOARD}`}>
            <img
              className="appice-icon"
          src={logoUrl && logoUrl.trim() !== "" ? logoUrl : appiceIcon}
  
              alt="logo"
              height={35}
            />
          </Link>
        </div>
        <div>
          {isDiagnosticsAuthenticated ? (
            <Link to="#" onClick={handleDiagnosticsLogout} className="me-2">Logout</Link>
          ) : loginUser.data.full_name ? (
            <div>
              <Dropdown
                menu={{ items }}
                trigger={["click"]}
                placement="bottomRight"
              >
                <span className="profile-trigger-wrapper" onClick={() => {}}>
                  <Avatar
                    alt={loginUser.data.full_name}
                    src={loginUser.data.userpicurl}
                  />

                  <span
                    className="user-name-label cursor-pointer"
                  >
                    <span className="d-sm-inline d-none">
                      {" "}
                      {loginUser.data.full_name}{" "}
                    </span>
                  </span>
                  <CaretDownFilled className="font-size-xsm" />
                </span>
              </Dropdown>
            </div>
          ) : (
            <>
            {loginUser.status !== "loading" && (
              isDeniedPage ? (
                // Special login for Access Denied page for custom jwt
                <Link
                  to="/login"
                  state={{ retryLogin: true }} //  pass retry flag only for denied page
                  className="retry-login-button"

               
                >
                  {t("loginLabel")}
                </Link>
              ) : (
                // Normal login link
                <Link to="/login" className="HeaderNav_links">
                                    {t("loginLabel")}

                </Link>
              )
            )}
          </>
          )}
        </div>
      </div>
    </nav>
  );
}

export default HeaderNav;
HeaderNav.defaultProps = {
  backgroundColor: "bg-white",
  name: "Guest",
  onclick: () => {},
};
